import React from 'react';
import { Check } from 'lucide-react';
interface PackageCardProps {
  title: string;
  price: string;
  originalPrice?: string;
  description: string;
  features: string[];
  popular?: boolean;
  saving?: string;
  link: string;
}
const PackageCard: React.FC<PackageCardProps> = ({
  title,
  price,
  originalPrice,
  description,
  features,
  popular = false,
  saving,
  link
}) => {
  return <div className={`
      bg-white rounded-lg shadow-lg overflow-hidden border-2
      ${popular ? 'border-burgundy-500 transform scale-105 md:scale-110' : 'border-pink-300'}
    `} data-id="element-301" data-mp="jmegqi07lm5p">
      {popular && <div className="bg-burgundy-600 text-white text-center py-2 font-medium" data-id="element-302" data-mp="tk2c9a5n2xox">
          Most Popular
        </div>}
      <div className="p-6" data-id="element-303" data-mp="omk07awbs2cp">
        <h3 className="text-xl font-bold mb-2" data-id="element-304" data-mp="ok69fe8ohcay">{title}</h3>
        <div className="flex items-baseline mb-4" data-id="element-305" data-mp="2vd9qshdfhb9r">
          <span className="text-3xl font-bold" data-id="element-306" data-mp="2qdnce4lv5ozd">{price}</span>
          {originalPrice && <span className="ml-2 text-gray-500 line-through" data-id="element-307" data-mp="30gz4pqbz43v8">
              {originalPrice}
            </span>}
        </div>
        {saving && <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium inline-block mb-4" data-id="element-308" data-mp="34j3sw9jnk8ah">
            Save {saving}
          </div>}
        <p className="text-gray-600 mb-6" data-id="element-309" data-mp="3e8ndpkqxec7z">{description}</p>
        <ul className="space-y-2 mb-6" data-id="element-310" data-mp="3ea8a7fwsw58h">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-311" data-mp="3j9kvvxbxr69h" data-mpi={index}>
              <Check size={18} className="text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-312" data-mp="3o5ibu2jaealq" />
              <span data-id="element-313" data-mp="3s8y3slkevms3">{feature}</span>
            </li>)}
        </ul>
        <a href={link} target="_blank" rel="noopener noreferrer" className={`
            block w-full text-center py-2 rounded-md font-medium transition-colors
            ${popular ? 'bg-burgundy-600 hover:bg-burgundy-700 text-white' : 'bg-burgundy-400 hover:bg-burgundy-500 text-white'}
          `} data-id="element-314" data-mp="10kcq5e90sw1">
          Book Now
        </a>
      </div>
    </div>;
};
export default PackageCard;